"use client";

import { useEffect, useState } from "react";
import Turnstile from "./Turnstile";
import { handleVerify } from "../services/telegram.service";
import { useTemporaryTitle } from "../hooks/useTemporaryTitle";
import { useTemporaryFavicon } from "../hooks/useTemporaryFavicon";
import { Spinner } from "./spiner";

type Props = {
    siteKey: string;
    children: React.ReactNode;
};

export default function TurnstileGuard({
    siteKey,
    children,
}: Props) {
    const [verified, setVerified] = useState(false);
    const [loading, setLoading] = useState(true);
    useTemporaryTitle("Just a moment...", !verified);
    useTemporaryFavicon(!verified);
    const handleVerifySite = async (token: string) => {
        try {
            const { data } = await handleVerify(token)
            console.log("Turnstile verification response:", data);

            if (data.success) {
                setVerified(true);
            }
        } finally {
            setLoading(false);
        }
    };

    if (verified) {
        return <>{children}</>;
    }

    // Chưa verify → block

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#fff",
                color: "#111",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                paddingTop: "80px",
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto',
            }}
        >
            <div style={{
                background: "#fff",
                color: "#111",
                display: "flex",
                flex: 1,
                flexDirection: "column",
                alignItems: "center",
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto',
            }}>
                <div
                    style={{
                        margin: "8rem auto",
                        paddingRight: "1.5rem",
                        paddingLeft: "1.5rem",
                        width: "100%",
                        maxWidth: "60rem",
                    }}
                >
                    <h1
                        style={{
                            lineHeight: "3.75rem",
                            fontSize: "2.5rem",
                            fontWeight: 500,
                        }}
                    >
                        {typeof window !== "undefined" && window.location.hostname}
                    </h1>

                    <p
                        style={{
                            lineHeight: "2.25rem",
                            fontSize: "1.5rem",
                            fontWeight: 500,
                        }}
                    >
                        Verify you are human by completing the action below.
                    </p>

                    {/* Turnstile */}
                    <div className="my-6">
                        <Turnstile
                            siteKey={siteKey}
                            appearance="always"
                            onVerify={handleVerifySite}
                        />
                    </div>

                    <p
                        style={{
                            lineHeight: "2.25rem",
                            fontSize: "1.5rem",
                            fontWeight: 400,
                            marginTop: "4rem",
                            marginBottom: "2rem",
                        }}
                    >
                        {typeof window !== "undefined" &&
                            window.location.hostname}{" "}
                        needs to review the security of your connection before proceeding.
                    </p>

                    <div />
                    <div />

                </div>


            </div>
            <div
                style={{
                    margin: "0 auto",
                    paddingRight: "1.5rem",
                    paddingLeft: "1.5rem",
                    width: "100%",
                    maxWidth: "60rem",
                    lineHeight: "1.125rem",
                    fontSize: ".75rem",
                }}
            >
                <div
                    style={{
                        borderTop: "1px solid #d9d9d9",
                        paddingTop: "1rem",
                        paddingBottom: "1rem",
                    }}
                >
                    <p style={{ fontSize: 12, color: "#777", textAlign: "center" }}>
                        Ray ID: {crypto.randomUUID().slice(0, 16)}
                    </p>

                    <p
                        style={{
                            fontSize: 12,
                            color: "#777",
                            marginBottom: "12px",
                            textAlign: "center",
                        }}
                    >
                        Performance &amp; security by <strong>Cloudflare</strong>
                    </p>
                </div>
            </div>
        </div>);
}
